import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const updateShippingBill = createAction(ACTION.UPDATE_SHIPPING_BILL.REQUEST, (id, codes) => ({id, codes}));
